export default {
    // ----------Title----------
    document: 'เอกสาร',
    generateFromDeliveryOrders: 'สร้างจากใบส่งของ',
    scopeTheRangeOfTheCustomerProfiles: 'กำหนดขอบเขตโปรไฟล์ลูกค้า',
    dateRange: 'ช่วงวันที่',
    documentDateforDeliveryOrders: 'วันที่ของเอกสารสำหรับใบส่งของ',
    generateFromContainer: 'สร้างจากภาชนะ',
    basicInformationAboutTheDocument: 'ข้อมูลพื้นฐานของเอกสาร',

    cashCollection: 'การเก็บเงินสด',
    optionalForCollectionUponDelivery: 'ตัวเลือกสำหรับเก็บเงินเมื่อส่งมอบ',
    hubDistribution: 'การกระจายสินค้าผ่านศูนย์กลาง',
    deliveryDistributionLocations: 'สถานที่กระจายการจัดส่ง',
    relatedProfilesAttachedToDocument: 'โปรไฟล์ที่เกี่ยวข้องที่แนบกับเอกสาร',

    approvalStatus: 'สถานะการอนุมัติ',
    relatedProfileInfoAttachedToDocument: 'ข้อมูลโปรไฟล์ที่เกี่ยวข้องที่แนบกับเอกสาร',
    documentNo: 'หมายเลขเอกสาร',
    collection: 'การเก็บรวบรวม',
    distributeVia: 'จัดส่งผ่านทาง',
    placeBy: 'สั่งซื้อโดย',
    detailInformationAboutTheItemsInvolved: 'ข้อมูลรายละเอียดเกี่ยวกับรายการที่เกี่ยวข้อง',
    generateSingleInvoice: 'สร้างใบแจ้งหนี้เดี่ยว',

    // -----------Drawer---------
    noPreviewInformation: 'ไม่มีข้อมูลตัวอย่างล่วงหน้า',
    previewCharges: 'ดูตัวอย่างค่าบริการ',
    no: 'หมายเลขซีเรียล',
    item: 'รายการ',
    particulars: 'รายละเอียดเฉพาะ',
    itemRate: 'อัตรารายการ',
    chargeAmount: 'จำนวนเงินค่าบริการ',
    shippingRates: 'อัตราค่าขนส่ง',
    totalSelected: 'รวมจำนวนที่เลือก',
    documents: 'เอกสาร',
    generateInvoiceNow: 'สร้างใบแจ้งหนี้ทันที',
    savedValidation: 'การตรวจสอบที่บันทึกไว้แล้ว',
    newValidation: 'การตรวจสอบใหม่',
    addNewValidation: 'เพิ่มการตรวจสอบใหม่',
    viewSavedValidation: 'ดูการตรวจสอบที่บันทึกไว้',
    inventory: 'คลังสินค้า',
    slot: 'ช่องเก็บสินค้า',
    rack: 'ชั้นวางสินค้า',
    availableQty: 'จำนวนที่มีอยู่',
    batchNo: 'หมายเลขล็อต',
    expiryDate: 'วันหมดอายุ',
    storage: 'พื้นที่จัดเก็บ',

    // -----------MUI-----------
    docNo: 'หมายเลขเอกสาร',
    docDate: 'วันที่เอกสาร',
    doNumber: 'หมายเลขใบส่งของ',
    invoiceNo: 'หมายเลขใบแจ้งหนี้',
    billingName: 'ชื่อผู้เรียกเก็บเงิน',
    billingAddress: 'ที่อยู่สำหรับการเรียกเก็บเงิน',
    date: 'วันที่',
    lastValidated: 'ตรวจสอบล่าสุด',
    validation: 'การตรวจสอบ',
    generateFromDO: 'สร้างจากใบส่งของ',
    documentDateFrom: 'วันที่เอกสารตั้งแต่',
    documentDateTo: 'วันที่เอกสารถึง',
    startQuery: 'เริ่มการค้นหา',
    code: 'รหัส',
    qty: 'จำนวน',
    loadFrom: 'โหลดจาก',
    billTo: 'เรียกเก็บเงินไปยัง',
    shipTo: 'จัดส่งไปยัง',
    subTotal: 'ผลรวมย่อย',
    total: 'ทั้งหมด',
    tax: 'ภาษี',
    discount: 'ส่วนลด',
    taxAmount: 'จำนวนภาษี',
    totalAmount: 'จำนวนเงินรวม',
    requiredAmount: 'จำนวนเงินที่ต้องชำระ',
    collectedAmount: 'จำนวนเงินที่เก็บได้',
    distributionLocation: 'สถานที่กระจายสินค้า',
    generateInvoices: 'สร้างใบแจ้งหนี้',
    marking: 'เครื่องหมาย',
    validated: 'ได้รับการตรวจสอบแล้ว',
    pending: 'รอดำเนินการ',
    balance: 'ยอดคงเหลือ',
    createdItemReceive: 'สร้างข้อมูลรับสินค้าแล้ว',
    containerLocation: 'ตำแหน่งของภาชนะ',
    documentLocation: 'ตำแหน่งของเอกสาร',
}